import { EMaterials } from '../../../../../types/buildersProjects';

const MATERIALS_ENUMS_TO_STRING = {
  [EMaterials.Blocks]: 'Блоки',
  [EMaterials.Brick]: 'Кирпич',
  [EMaterials.GluedLaminatedTimber]: 'Клееный брус',
  [EMaterials.SolidTree]: 'Цельное дерево',
  [EMaterials.FrameHouses]: 'Каркас',
  [EMaterials.Monolith]: 'Монолит',
  [EMaterials.Sip]: 'SIP-технологии',
  [EMaterials.Other]: 'Другое',
};

export const getMaterialsLabel = (materials: EMaterials[]): string | undefined => {
  if (!materials.length) {
    return;
  }

  return Object.entries(MATERIALS_ENUMS_TO_STRING)
    .map(data => {
      const [materialEnum, materialStr] = data as [EMaterials, string];

      return materials.includes(materialEnum) ? materialStr : null;
    })
    .filter(Boolean)
    .join(', ');
};
